import { useState } from 'react';
import { styled, alpha } from '@mui/material/styles';
// LaTeX
import Latex from 'react-latex-next';
// mui components
import Menu, { MenuProps } from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import { Tooltip } from '@mui/material';
// mui icons
import AddIcon from '@mui/icons-material/Add';
import Filter1Icon from '@mui/icons-material/Filter1';
import Filter2Icon from '@mui/icons-material/Filter2';
import Filter3Icon from '@mui/icons-material/Filter3';
import Filter4Icon from '@mui/icons-material/Filter4';
import Filter5Icon from '@mui/icons-material/Filter5';
import Filter6Icon from '@mui/icons-material/Filter6';
import Filter7Icon from '@mui/icons-material/Filter7';
import { SeccionState } from '../../../store/slices/seccion';

const StyledMenu = styled((props: MenuProps) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    {...props}
  />
))(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color:
      theme.palette.mode === 'light' ? 'rgb(55, 65, 81)' : theme.palette.grey[300],
    boxShadow:
      'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
    '& .MuiMenu-list': {
      padding: '4px 0',
    },
    '& .MuiMenuItem-root': {
      '& .MuiSvgIcon-root': {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      '&:active': {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity,
        ),
      },
    },
  },
}));

type Props = {
  handleCrearEjercicio: Function
  seccion: SeccionState
}

const MenuCrearEjercicio = ({handleCrearEjercicio, seccion}: Props) => {

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleTipo = (tipo: string) => {
    handleCrearEjercicio(seccion, tipo)
    handleClose();
  }

  return (
    <div>
      <Tooltip title="Menú Ejercicio">
        <IconButton
          size='small'
          onClick={handleClick}
        >
          <AddIcon fontSize='inherit' />
        </IconButton>
      </Tooltip>
      <StyledMenu
        id="demo-customized-menu"
        MenuListProps={{
          'aria-labelledby': 'demo-customized-button',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <MenuItem onClick={() => handleTipo('numerico')} disableRipple>
          <Filter1Icon />
          Número
        </MenuItem>
        <MenuItem onClick={() => handleTipo('intervalo')} disableRipple>
          <Filter2Icon />
          Conjunto
        </MenuItem>
        <MenuItem onClick={() => handleTipo('punto')} disableRipple>
          <Filter3Icon />
          <Latex>{`Punto con entradas en \\(\\R\\)`}</Latex> 
        </MenuItem>
        <MenuItem onClick={() => handleTipo('vector')} disableRipple>
          <Filter4Icon />
          <Latex>{`Vector con entradas en \\(\\R\\)`}</Latex> 
        </MenuItem>
        <MenuItem onClick={() => handleTipo('formula')} disableRipple>
          <Filter5Icon />
          <Latex>{`Fórmula en la variable \\(x\\)`}</Latex> 
        </MenuItem>
        <MenuItem onClick={() => handleTipo('ecuacionXY')} disableRipple>
          <Filter6Icon />
          <Latex>{`Ecuación en las variables \\(x\\) e \\(y\\)`}</Latex> 
        </MenuItem>
        <MenuItem onClick={() => handleTipo('antiderivada')} disableRipple>
          <Filter7Icon />
          <Latex>{`Antiderivada en las variables \\(x\\) y \\(C\\)`}</Latex> 
        </MenuItem>
        <Divider sx={{ my: 0.5 }} />
        <MenuItem onClick={() => handleTipo('seleccion-multiple')} disableRipple>
          <Filter1Icon />
          Seleccion Múltiple
        </MenuItem>
        {/* <MenuItem onClick={() => handleTipo('verdadero-falso')} disableRipple>
          <Filter2Icon />
          Verdadero o Falso
        </MenuItem> */}
      </StyledMenu>
    </div>
  )
}

export default MenuCrearEjercicio;